exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container___35U4w {\n  padding: 40px;\n  display: flex;\n  flex-direction: column;\n}\n.title___3eM2P {\n  margin-top: 32px;\n  font-family: 'proxima-nova', 'Helvetica', Arial, sans-serif;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 1.2em;\n}\n.subtitle___2Uj-U {\n  margin: 12px 0 32px;\n  color: #505050;\n  font-family: 'proxima-nova', 'Helvetica', Arial, sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.5em;\n}\n.body___29cGw {\n  border-top: 1px solid #d9d9d9;\n}\n.footer___2pp56 {\n  padding-top: 40px;\n  text-align: right;\n}\n", ""]);

// exports
exports.locals = {
	"container": "container___35U4w",
	"title": "title___3eM2P",
	"subtitle": "subtitle___2Uj-U",
	"body": "body___29cGw",
	"footer": "footer___2pp56"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/stylesheets/common/_modal.module.less
// module id = 2454
// module chunks = 68